import { Injectable } from '@angular/core';

@Injectable()
export class LMBrowserUtilService {
// browsers
  public isIE = false;
  public isIE11 = false;
  public isEdge = false;
  public isSafari = false;
  public isChrome = false;
  public isFirefox = false;
  public isOpera = false;

  public version = parseInt(navigator.appVersion, 10);
  public fullVersion = parseFloat(navigator.appVersion).toString();
  public language = 'en-us';
  public name = '';

  // platforms
  public isMAC = false;
  public isWIN = false;
  public isLinux = false;

  public osVersion = 0;
  public isXP = false;

  // mobility
  public isMobile = false;	// use combination of browsers and/or platforms to further determine mobile platform

  public verOffset: number;
  public index: number;
  public ua: string = navigator.userAgent;
  public platform: string;

  // 64-bit IE
  public isWin64: boolean;

  // mobile attributes; see ControllerBase.java > MOBILE_SPECIFIC_SUBSTRING
  private aryMobileAttr = ['iPhone', 'Android', 'MIDP', 'Opera Mobi', 'Opera Mini', 'BlackBerry', 'HP iPAQ', 'IEMobile',
    'MSIEMobile', 'Windows Phone', 'HTC', 'LG', 'MOT', 'Nokia', 'Symbian', 'Fennec', 'Maemo', 'Tear', 'Midori',
    'armv', 'Windows CE', 'WindowsCE', 'Smartphone', '240x320', '176x220', '320x320', '160x160', 'webOS', 'Palm',
    'Sagem', 'Samsung', 'SGH', 'SIE', 'SonyEricsson', 'MMP', 'UCWEB'];

  constructor( ) {
    this.initialize();
  }

  private initialize() {
    if ((this.verOffset = this.ua.indexOf('MSIE')) !== -1) {
      // the true version is after 'MSIE' in userAgent
      this.isIE = true;
      this.isIE11 = true;
      this.name = 'Microsoft Internet Explorer';
      this.fullVersion = this.ua.substring(this.verOffset + 5);

    } else if (this.ua.indexOf('Trident') !== -1) {
      // the true version is after 'rv:' in userAgent
      this.isIE = true;
      this.isIE11 = true;
      this.name = 'Microsoft Internet Explorer';
      this.verOffset = this.ua.indexOf('rv');
      this.fullVersion = this.ua.substring(this.verOffset + 3);

    } else if ((this.verOffset = this.ua.indexOf('Edge')) !== -1 || (this.verOffset = this.ua.indexOf('Edg')) !== -1) {
      this.isIE = true;
      this.isEdge = true;
      this.name = 'Microsoft Internet Explorer';
      this.fullVersion = this.ua.substring(this.ua.indexOf('Edge') + 5);

    } else if (this.ua.indexOf('Opera') !== -1) {
      // the true version is after 'Version/'
      this.isOpera = true;
      this.name = 'Opera';
      this.verOffset = this.ua.indexOf('Version');
      this.fullVersion = this.ua.substring(this.verOffset + 8);

    } else if ((this.verOffset = this.ua.indexOf('Chrome')) !== -1) {
      // the true version is after 'Chrome'
      this.isChrome = true;
      this.name = 'Chrome';
      this.fullVersion = this.ua.substring(this.verOffset + 7);

    } else if (this.ua.indexOf('Safari') !== -1) {
      // the true version is after 'Version/'
      this.isSafari = true;
      this.name = 'Safari';
      this.verOffset = this.ua.indexOf('Version');
      this.fullVersion = this.ua.substring(this.verOffset + 8);

    } else if ((this.verOffset = this.ua.indexOf('Firefox')) !== -1) {
      // the true version is after 'Firefox'
      this.isFirefox = true;
      this.name = 'Firefox';
      this.fullVersion = this.ua.substring(this.verOffset + 8);
    }

    // trim the fullVersion string at semicolon/space if present
    if ((this.index = this.fullVersion.indexOf(';')) !== -1) {
      this.fullVersion = this.fullVersion.substring(0, this.index);
    }

    if ((this.index = this.fullVersion.indexOf(' ')) !== -1) {
      this.fullVersion = this.fullVersion.substring(0, this.index);
    }

    if ((this.index = this.fullVersion.indexOf(')')) !== -1) {
      this.fullVersion = this.fullVersion.substring(0, this.index);
    }

    this.version = parseInt(this.fullVersion.toString(), 10);

    if (isNaN(this.version)) {
      this.fullVersion = parseFloat(navigator.appVersion).toString();
      this.version = parseInt(navigator.appVersion, 10);
    }

    // language
    // this.language = ((this.isIE) ? navigator.userLanguage : navigator.language).toLowerCase();

    // platforms
    if (this.ua.indexOf('Windows') >= 0) {
      this.isWIN = true;
      const idx = this.ua.indexOf('Windows NT ');

      if (idx !== -1) {
        this.osVersion = parseFloat(this.ua.substring(idx + 11));

        if (this.osVersion >= 5.1) {
          this.isXP = true;
        }
      }
    } else if (this.ua.indexOf('Mac') >= 0) {
      this.isMAC = true;

    } else if (this.ua.indexOf('Linux') >= 0) {
      this.isLinux = true;
    }

    // mobility
    const uaLower = this.ua.toLowerCase();
    this.isMobile = !!this.aryMobileAttr.find(mobItem => uaLower.indexOf(mobItem.toLowerCase()) >= 0);

    this.platform = (this.isMAC) ? 'Macintosh' :
      (this.isWIN) ? 'Windows' :
        (this.isLinux) ? 'Linux' : 'unknown';

    // 64-bit IE
    this.isWin64 = (this.ua.indexOf('Win64') >= 0);
  }

  public get isValid(): boolean {
    if (this.isMobile) {
      return true;

    } else if (this.isIE && this.version >= 9) {
      return true;

    } else if (this.isFirefox && this.version >= 8) {
      return true;

    } else if (this.isSafari && this.version >= 5) {
      return true;

    } else if (this.isChrome) {
      return true;
    }

    return false;
  };
}
